import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdiSvg', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
      },
      theme: {
        themes: {
          light: {
            appColor: "#644DED",
            backgroundColor: "#EBEEF7",
            avatarColor: "#DAD3FF",
            appBlack: "#161C27",
            appGray: "#8692A6",
            appBlue: "#06F2AF",
            liteGray: "#F5F5F5",
          },
        },
      },
});
